import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import AdminApp from './AdminApp.tsx';
import './index.css';

// Disable browser's native scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Force scroll to top on page load
window.scrollTo({ top: 0, behavior: 'auto' });
document.documentElement.scrollTop = 0;
document.body.scrollTop = 0;

// Check for admin portal access via hidden URL
const isAdminRoute =
  window.location.pathname === '/cte-admin-portal-2025' ||
  window.location.hash === '#/cte-admin-portal-2025';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>{isAdminRoute ? <AdminApp /> : <App />}</React.StrictMode>
  );
}
